// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");

var $ = require("./lib/qsa");

$("[data-batter]").forEach(el => el.addEventListener("click", function(e) {
  var batter = this.getAttribute("data-batter");
  var current = document.querySelector(".batter.selected");
  var next = document.querySelector(".batter." + batter);
  current.classList.remove("selected");
  next.classList.add("selected");
}));